<template>
  <div class="tw-p-7">
    <div>
      <h2 class="tw-text-xl tw-font-bold tw-text-center tw-mb-5">
        Calendars
      </h2>

      <div v-if="availablePlatforms?.length > 0">
        <div class="tw-flex tw-flex-col tw-gap-5">
          <MeetingBotCalendarToggle
            v-for="platform in availablePlatforms"
            :key="platform.name.internal"
            :platform="platform"
            :active-calendars="activeCalendars"
            @created="handleCalenderCreated"
            @deleted="handleCalendarDeleted"
          />
        </div>

        <p class="tw-max-w-md tw-text-left tw-text-sm tw-text-gray-400 tw-mt-5">
          When a calendar is enabled,
          the YourStake meeting bot will try to join any meeting that you are the host of.
          Soon we will be adding more options that will allow you to customize the bot's behavior.
        </p>
      </div>

      <div
        v-else
        class="tw-max-w-lg"
      >
        <p class="tw-text-center tw-text-gray-400">
          You haven't connected any calendar accounts yet.
          Please visit the
          <router-link to="/advisor/integrations">
            integrations page
          </router-link>
          to connect your Google or Outlook calendar.
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import MeetingBotCalendarToggle from './MeetingBotCalendarToggle.vue';

import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

const CALENDAR_PLATFORMS = [
  {
    name: {
      internal: 'Google Calendar',
      external: 'google_calendar',
    },
  },
  {
    name: {
      internal: 'Outlook Calendar',
      external: 'microsoft_outlook',
    },
  },
];

export default {
  name: 'MeetingCalendarSettings',
  components: {
    MeetingBotCalendarToggle,
  },
  props: [/* Inputs */],
  data() {
    return {
      platforms: CALENDAR_PLATFORMS,
      activeCalendars: undefined,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
    availablePlatforms() {
      return this.platforms.filter(platform => {
        const name = platform.name.internal;
        return this.advisorStore.activeOAuthConnections?.[name];
      });
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
    this.getCalendars();
  },
  mounted() {},
  updated() {},
  methods: {
    async getCalendars() {
      const res = await fetch('/api/v1/recall/calendars/', {
        method: 'GET',
        headers: this.headers,
      });
      const data = await res.json();
      console.log(data);

      const calendars = {};
      for (const cal of data) {
        calendars[cal.platform] = {
          id: cal.id,
          platform: cal.platform,
        };
      }
      this.activeCalendars = calendars;
    },
    handleCalenderCreated(calendar) {
      if (!this.activeCalendars) this.activeCalendars = {};
      this.activeCalendars = {
        ...this.activeCalendars,

        [calendar.platform]: {
          id: calendar.id,
          platform: calendar.platform,
        },
      };
    },
    handleCalendarDeleted(platform) {
      this.activeCalendars = {
        ...this.activeCalendars,
        [platform.name.external]: undefined,
      };
    },
  },
};
</script>


<style scoped>

</style>
